export const STEPER_CONSENT = "ProgressSteper.Consent";
export const STEPER_PHONE_VERIFICATION = "ProgressSteper.Phone_verification";
export const STEPER_SWITCH_TO_MOBILE = "ProgressSteper.Switch_to_mobile";
export const STEPER_FACE_CAPTURE = "ProgressSteper.Face_capture";
export const STEPER_DOCUMENT_CAPTURE = "ProgressSteper.Document_capture";
export const STEPER_THANK_YOU = "ProgressSteper.Thank_you";
export const STEPER_NFC = "ProgressSteper.NFC";
